import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import NativeTable from '../../../components/NativeTable/NativeTable';

import { Popover, PopoverBody, PopoverHeader, Alert } from 'reactstrap';

import {
    Button,
    ButtonToolbar,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle
} from "reactstrap";

import { withTranslation } from '../../../i18n/LanguageContext';
import { loadProductCatalogIfNeeded } from '../../../actions/productCatalog';
import { getProductsRequest, deleteProductRequest, setCurProductId, loadProductRequest } from '../../../actions/products'
import { getMerchantId } from '../../../utils/merchant';
import { mockProduct } from '../../../model/mockProduct'
import { getProductsByCategoryId } from '../../../selectors/products';

import Loader from '../../../components/Loader/Loader';
import Widget from '../../../components/Widget/Widget';
import s from './ProdList.module.scss';

import cx from 'classnames';

class ProdList extends React.Component {
    
    static propTypes = {
        products: PropTypes.array,
        dispatch: PropTypes.func.isRequired,
    };

    static defaultProps = {
        products: []
    };

    state = {
        popovers: {},
        promoAlert: false,
    };

    constructor() {
        super();
        this.apiFormatter = this.apiFormatter.bind(this);
    }

    loadProducts = () => {
        this.props.dispatch(loadProductCatalogIfNeeded());
    }

    componentDidMount() {
        this.loadProducts();
    }

    componentDidUpdate(prevProps) {
        const merchantId = getMerchantId(this.props.merchant);
        const prevMerchantId = getMerchantId(prevProps.merchant);
        if (merchantId !== prevMerchantId) {
            this.loadProducts();
        }
    }

    showPromoAlert() {
        this.setState({promoAlert: true});
    }

    imageFormatter(cell) {
        if (cell == "" || cell == null ) {
            return (<div></div>);
        } else {
            return (
                <img src={cell} alt="..." className={s.image} title="image"/>
            )
        }
    }

    getCategoryById = (id) => {
        let category = this.props.categories.filter(function( c ) {
            return c.CategoryId == id;
        });

        if (category.length > 0) {
            return category[0]
        } else {
            return null;
        }
    }
    
    categoryFormatter = (cell) => {
        if (cell) {
            let category = this.getCategoryById(cell);
            return category == null ? "" : category.Name;
        } else {
            return ""
        }
    }

    variationsFormatter = (cell) => {
        return cell ? (
            <div className="variations_col"><span>{cell.length}</span><i className="zmdi zmdi-storage"></i></div>
        ) : ""
    }

    stockFormatter = (cell, row) => {
        const variations = (row && row.Variations) || [];
        if (variations.length > 0) {
            return variations.reduce((sum, v) => sum + (Number(v.Inventory) || 0), 0);
        }
        return cell == null ? 0 : cell;
    }

    isInternalItem = (row) => {
        if (!row) return false;
        if (row.InternalOnly) return true;
        const category = this.getCategoryById(row.CategoryId);
        return !!(category && (category.InternalOnly || category.internalOnly));
    }

    nameFormatter = (cell, row) => {
        return (
            <span>
                {cell}
                {this.isInternalItem(row) ? <span className={s.internalBadge}>{this.props.t('productsTabs.internal')}</span> : null}
            </span>
        );
    }

    getProducts = () => {
        const {curCategoryId, products} = this.props;

        if (curCategoryId != 0) {
            var data = products.filter(function( p ) {
                return p.CategoryId == curCategoryId;
            });
    
            return data;
        } else {
            return products;
        }
    }

    editProduct(id) {
        //const product = this.getProductById(id);
        this.props.dispatch(setCurProductId(id));
        this.props.history.push('/admin/products/prod_list/create');
    }

    getProductById = (id) => {
        const {products} = this.props;
        var data = products.filter(function( p ) {
            return p.ProductId == id;
        });

        var product = {... mockProduct};
        if (data.length > 0) {
            product = {... data[0]};
        }
            
        return product;
    }

    deleteProduct(id) {
        this.togglePopover(id);
        this.props.dispatch(deleteProductRequest(id));
    }

    togglePopover(id) {
        let newState = {...this.state};
        if (!this.state.popovers[id]) {
            newState.popovers[id] = true;
        } else {
            newState.popovers[id] = !newState.popovers[id];
        }
        this.setState(newState);
    }

    apiFormatter(cell, row) {
        return (
            <ButtonToolbar className="">
                <button id={'popoverDelete_' + row.ProductId} className="btn">
                    {this.props.isDeleting && this.props.idToDelete === row.ProductId ? <Loader size={14}/> :
                        <div><i className="zmdi zmdi-delete"></i></div>
                    }
                </button>
                <button className="btn" onClick={()=> this.editProduct(row.ProductId)}>
                    <div><i className="zmdi zmdi-edit"></i></div>
                </button>
                
                <Popover className="popover-danger" target={'popoverDelete_' + row.ProductId} placement="top" isOpen={this.state.popovers[row.ProductId]}
                         toggle={()=>{this.togglePopover(row.ProductId)}}
                >
                    <PopoverHeader className="px-5">{this.props.t('common.confirm')}</PopoverHeader>
                    <PopoverBody className="px-5 d-flex justify-content-center">
                        <ButtonToolbar>
                            <Button color="success" size="xs" onClick={() => {this.deleteProduct(row.ProductId)}}>
                                {this.props.t('common.yes')}
                            </Button>
                            <Button color="danger" size="xs" onClick={() => {this.togglePopover(row.ProductId)}}>
                                {this.props.t('common.no')}
                            </Button>
                        </ButtonToolbar>
                    </PopoverBody>
                </Popover>
            </ButtonToolbar>
        )
    }

    renderSizePerPageDropDown = (props) => {
        const limits = [];
        props.sizePerPageList.forEach((limit) => {
            limits.push(<DropdownItem key={limit}
                                      onClick={() => props.changeSizePerPage(limit)}>{limit}</DropdownItem>);
        });

        return (
            <Dropdown isOpen={props.open} toggle={props.toggleDropDown}>
                <DropdownToggle color="default" caret>
                    {props.currSizePerPage}
                </DropdownToggle>
                <DropdownMenu>
                    {limits}
                </DropdownMenu>
            </Dropdown>
        );
    };

    render() {
        const options = {
            sizePerPage: 10,
            paginationSize: 3,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
        };

        const data = this.getProducts();

        return (
            <div className="prod_list">
                <div className="tab_header">
                    <h1>
                        <span className="d-block">{this.props.t('productsTabs.productsTitle')}</span>
                    </h1>
                    <button type="button" className="btn" onClick={() => this.editProduct(0)}>{this.props.t('common.add')}</button>
                </div>
                <Widget>
                    <div className="order_list">
                        <NativeTable
                            data={data}
                            searchFields={['SKU', 'Name']}
                            columns={[
                                { key: 'SKU', header: this.props.t('productsTabs.sku'), hideMobile: true },
                                { key: 'Picture', header: this.props.t('common.image'), render: (cell) => this.imageFormatter(cell) },
                                { key: 'Name', header: this.props.t('productsTabs.product'), render: (cell, row) => this.nameFormatter(cell, row) },
                                { key: 'CategoryId', header: this.props.t('productsTabs.category'), render: (cell) => this.categoryFormatter(cell), hideMobile: true },
                                { key: 'Variations', header: this.props.t('productsTabs.variationsShort'), render: (cell) => this.variationsFormatter(cell), hideMobile: true, className: 'hide-sm' },
                                { key: 'Price', header: this.props.t('productsTabs.priceUsd'), hideMobile: true },
                                { key: 'Inventory', header: this.props.t('productsTabs.inStock'), hideMobile: true, render: (cell, row) => this.stockFormatter(cell, row) },
                                { key: 'ProductId', header: this.props.t('common.action'), render: (cell, row) => this.apiFormatter(cell, row) },
                            ]}
                        />
                    </div>
                </Widget>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        //products: getProductsByCategoryId(state),
        products: state.products.data,
        categories: state.products.categories,
        curCategoryId: state.products.curCategoryId,
        merchant: state.auth.merchant,
        isReceiving: state.products.isReceiving,
        isDeleting: state.products.isDeleting,
        idToDelete: state.products.idToDelete,
        catalogError: state.products.error,
    };
}

export default withRouter(connect(mapStateToProps)(withTranslation(ProdList)));

